module.exports = "<p>example2 works!</p>\r\n"